import React from 'react';

export class ErrorBoundary extends React.Component{
  constructor(props){super(props);this.state={hasError:false};}
  static getDerivedStateFromError(){return{hasError:true};}
  componentDidCatch(err){console.error('Reading Quest error:',err);}
  render(){
    if(this.state.hasError)return React.createElement('div',{className:'px-6 py-16 text-center'},
      React.createElement('div',{className:'mx-auto max-w-md rounded-finley-xl bg-finley-bg-card px-6 py-10 shadow-finley-md'},
        React.createElement('div',{className:'mb-4 text-6xl'},'😵'),
        React.createElement('h2',{className:'mb-2 font-finley-display text-3xl text-finley-text'},'Something went wrong'),
        React.createElement('p',{className:'mb-6 text-base text-finley-text-light'},'Your data is safe. Tap below to reload.'),
        React.createElement('button',{onClick:()=>window.location.reload(),className:'min-h-[48px] rounded-finley-lg bg-finley-secondary px-8 py-3 font-finley-display text-lg font-semibold text-white shadow-finley-md'},'Try Again')
      )
    );
    return this.props.children;
  }
}
